import styled from "styled-components";

export const StyledWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutralsTextTint85};
  border-radius: 8px;
  padding: 16px 0;
  margin-top: 26px;
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }

  > div:first-child {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 32px 22px 32px;

    color: ${({ theme }) => theme.colors.neutralsBlack};
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;

      > h3 {
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        margin: 0;
      }
    }
  }

  > div:nth-child(2),
  > div:nth-child(4) {
    margin: 0 32px;
    width: calc(100% - 64px);
  }

  > div:nth-child(3) {
    transition: max-height 0.5s;
    overflow: hidden;

    > div:nth-child(even) {
      background: ${({ theme }) => theme.colors.secondaryBackgroundLightTint20};
    }
  }

  > div:nth-child(5) {
    display: flex;
    justify-content: center;
    padding: 16px 32px;

    > button {
      background: none;
      border: none;
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.DesktopCopySmallBold}
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;

      > svg {
        transform: ${({ showall }) =>
          showall ? "rotate(180deg)" : "rotate(0deg)"};
        transition: transform 0.5s;
      }
    }
  }
`;

export const StyledWinnerRow = styled.div`
  padding: 16px 32px;
  display: flex;
  justify-content: space-between;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  transition: visibility 0.5s;

  ${({ theme }) => theme.media.onlySmallMobile`
    flex-direction: column;
  `}

  >div {
    display: flex;

    &:first-child {
      align-items: center;
      gap: 8px;

      > img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }

      > div {
        display: flex;
        gap: 8px;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        > h4 {
          color: ${({ theme }) => theme.colors.neutralsText};
          ${({ theme }) => theme.fontStyles.InterfaceCopyLarge}
          margin: 0;
        }

        > span {
          color: ${({ theme }) => theme.colors.neutralsTextLight};
          ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
        }
      }
    }

    &:nth-child(2) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      gap: 6px;

      ${({ theme }) => theme.media.onlySmallMobile`
        flex-direction: row;
        justify-content: flex-start;
        margin-left: 56px;
      `}

      >a.solution-preview {
        color: ${({ theme }) => theme.colors.primaryText};
        ${({ theme }) => theme.fontStyles.InterfaceCopyBold}
        text-decoration: none;
      }

      > a.certificate-preview {
        color: ${({ theme }) => theme.colors.neutralsTextLight};
        ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
        text-decoration: none;
      }
    }
  }
`;
